var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { pick } from 'ramda';
import { countTotalDuration } from '../../../../../app/common/helpers/appointments';
var extractCustomerName = function (name) {
    // split in 2 by first space
    var _a = (name || '').split(/\s+(.*)/), firstName = _a[0], lastName = _a[1];
    return { firstName: firstName, lastName: lastName };
};
var getSelectedServices = function (allServices, selectedServices) {
    return allServices.filter(function (service) { return selectedServices[service.id]; });
};
var getWalkInServices = function (services) { return (services || []).map(pick(['id', 'name'])); };
export var getWalkInListItemDto = function (_a) {
    var values = _a.values, allServices = _a.allServices;
    var selectedServices = getSelectedServices(allServices, values.services);
    return __assign(__assign({ customerId: values.customerId }, extractCustomerName(values.name)), { phone: values.phone, email: values.email, services: getWalkInServices(selectedServices), duration: countTotalDuration(selectedServices), appointmentNote: values.appointmentNotes, customerNote: values.notes });
};
